import { AttendanceEnumsOvertimePoolUpdateFrequencyEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { RESET_FREQUENCIES } from 'modules/attendance/store/models/BalanceCarryover'

type ResetFrequency = (typeof RESET_FREQUENCIES)[keyof typeof RESET_FREQUENCIES]

const updateFrequencyTypeMap: Record<string, AttendanceEnumsOvertimePoolUpdateFrequencyEnum> = {
  daily: 'daily',
  monthly: 'monthly',
  weekly: 'weekly',
  at_cycle_end: 'at_cycle_end',
  on_approval: 'on_approval',
  yearly: 'monthly',
  never: 'monthly',
}

export const updateFrequencyToEnum = (
  frequency: string
): AttendanceEnumsOvertimePoolUpdateFrequencyEnum => {
  const result = updateFrequencyTypeMap[frequency]
  if (!result) {
    throw new Error(`Unknown frequency: ${frequency}`)
  }
  return result
}

export const mapFrequencyOptionsToBalanceCarryover = (frequency: ResetFrequency) => {
  switch (frequency) {
    case RESET_FREQUENCIES.CUSTOM_PERIOD:
      return [
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.monthly'),
          value: 'monthly',
        },
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.daily'),
          value: 'daily',
        },
      ]
    case RESET_FREQUENCIES.WEEKLY:
      return [
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.weekly'),
          value: 'weekly',
        },
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.daily'),
          value: 'daily',
        },
      ]
    case RESET_FREQUENCIES.MONTHLY:
      return [
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.monthly'),
          value: 'monthly',
        },
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.daily'),
          value: 'daily',
        },
      ]
    case RESET_FREQUENCIES.NEVER:
      return [
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.monthly'),
          value: 'monthly',
        },
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.daily'),
          value: 'daily',
        },
      ]
    case RESET_FREQUENCIES.YEARLY:
      return [
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.monthly'),
          value: 'monthly',
        },
        {
          label: i18n.t('time_tracking.settings.balance.reset_frequency.daily'),
          value: 'daily',
        },
      ]
    default:
      throw new Error(`Unknown options for type: ${frequency}`)
  }
}
